import { render, staticRenderFns } from "./danGeShangPingZhuangXiangXinXi.vue?vue&type=template&id=285d7862&scoped=true&"
import script from "./danGeShangPingZhuangXiangXinXi.vue?vue&type=script&lang=js&"
export * from "./danGeShangPingZhuangXiangXinXi.vue?vue&type=script&lang=js&"
import style0 from "./danGeShangPingZhuangXiangXinXi.vue?vue&type=style&index=0&id=285d7862&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285d7862",
  null
  
)

export default component.exports